import { translateApiMessages, translateFieldErrors } from './translateApiMessage';

export function extractApiErrorPayload(error) {
  return error?.response?.data ?? error ?? {};
}

export function flattenValidationErrors(errors) {
  if (!errors || typeof errors !== 'object') {
    return [];
  }

  return Object.values(errors).flat().filter(Boolean);
}

export function getApiErrorMessages(payload, fallbackMessage = 'Something went wrong') {
  const data = extractApiErrorPayload(payload);
  const messages = flattenValidationErrors(data?.errors);

  if (messages.length > 0) {
    return messages;
  }

  if (typeof data?.message === 'string' && data.message.trim() !== '') {
    return [data.message];
  }

  if (typeof payload === 'string' && payload.trim() !== '') {
    return [payload];
  }

  return [fallbackMessage];
}

export function formatApiError(payload, fallbackMessage = 'Something went wrong', language) {
  return translateApiMessages(getApiErrorMessages(payload, fallbackMessage), language).join(' • ');
}

export function enrichApiError(error, fallbackMessage = 'Something went wrong') {
  const payload = extractApiErrorPayload(error);
  const messages = getApiErrorMessages(error, fallbackMessage);

  if (error && typeof error === 'object') {
    error.apiMessages = messages;
    error.formattedMessage = translateApiMessages(messages).join(' • ');
    error.fieldErrors = payload?.errors ?? null;
  }

  return error;
}

export function applyValidationErrorsToForm(form, errors, language) {
  if (!form || !errors || typeof errors !== 'object') {
    return;
  }

  const translatedErrors = translateFieldErrors(errors, language);

  form.setFields(
    Object.entries(translatedErrors).map(([name, fieldErrors]) => ({
      name,
      errors: Array.isArray(fieldErrors) ? fieldErrors : [String(fieldErrors)],
    })),
  );
}
